module.exports = __webpack_public_path__ + "img/ico-success.fc97233c.svg";